import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      flexDirection: 'column',
      [theme.breakpoints.only('xs')]: {
        minHeight: '80vh',
      },
    },

    disclaimer: {
      textAlign: 'center',
      '& h1': {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        color: theme.palette.primary.main,
        fontSize: 20,
        fontWeight: 'bold',
      },
      '& p': {
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(3),
      },
    },
    button: {
      borderRadius: 20,
    },
    checkbox: {
      alignItems: 'flex-start',
    },
    checkboxText: {
      paddingTop: theme.spacing(1),
    },
    input: {
      borderRadius: 20,
      '& svg': {
        color: theme.palette.primary.light,
      },
      '& .MuiSelect-root': {
        borderRadius: 20,
      },
    },
    inputText: {
      '& svg': {
        width: 18,
        height: 18,
      },
    },
    vehicleCard: {
      borderRadius: 20,
      padding: theme.spacing(2),
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: 20,
      width: '100%',
      border: `1px solid rgba(0, 0, 0, 0.23)`,
      transition: theme.transitions.create(['border-color'], {
        duration: theme.transitions.duration.short,
        easing: theme.transitions.easing.easeInOut,
      }),
      '&:hover': {
        borderColor: '#646464',
      },
      '&:active': {
        borderColor: theme.palette.primary.main,
      },
      '&.selected': {
        borderWidth: 2,
        borderColor: theme.palette.primary.main,
      },
    },
    overline: {
      textTransform: 'none',
      fontWeight: theme.typography.fontWeightBold,
    },
    date: {
      textTransform: 'capitalize',
    },
  })
);

export default useStyles;
